module.exports = __webpack_public_path__ + "static/works-torqen-c004deb404a7f8f9f280c2291290e99e.jpg";